/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Filter_Class_Listaspectcontainsoraspect13Inputs */



/**

* @param {_Filter_Class_Listaspectcontainsoraspect13Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _filter_class_listaspectcontainsoraspect13 = /** @type {((inputs?: _Filter_Class_Listaspectcontainsoraspect13Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Filter_Class_Listaspectcontainsoraspect13Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("beinhaltet eins von")
});
export { _filter_class_listaspectcontainsoraspect13 as "_filter_class_ListAspectCONTAINSORAspect" }